const get = state => state.backoffice;

export const getBackofficeTablesDataSelector = state => get(state).tablesData;

export const getBrandUploadTablesDataSelector = state => get(state).tablesData.tableUpload;

export const getComputedFiltersSelector = state => get(state).filterSelected;
